/**
 * The page sizes a paginated table offers by default. The search schemas
 * accept only these for a table's size parameter (navigation/searchParams).
 */
export const TABLE_PAGE_SIZES = [10, 25, 50, 100] as const;
